<template>
  <div class="report-header">
    <div class="left">
      <div class="content">
        <div class="inner"></div>
      </div>
    </div>
    <div class="middle">
      <div class="content">
        <div class="inner">
          <span class="title">{{title}}</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="content">
        <div class="inner">
          <span class="time">{{nowTime}}</span>
          <span class="week">{{nowWeek}}</span>
          <span class="date">{{nowDate}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {parseTime} from '@/utils/tools'

export default {
  name: 'reportHeader',
  props:{
    title:{
      type: String,
      default:''
    }
  },
  data() {
    return {
      nowTime: '',
      nowDate: '',
      nowWeek: '',
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.setTime()
    }, 1000)
  },
  methods: {
    setTime() {
      let timeObj=parseTime('', '{y}-{m}-{d} 星期{a} {h}:{i}:{s}');
      this.nowTime = `${timeObj.h}:${timeObj.i}:${timeObj.s}`;
      this.nowDate = `${timeObj.y}/${timeObj.m}/${timeObj.d}`;
      this.nowWeek = `周${timeObj.a}`
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped lang="scss">
.report-header {
  display: flex;
  height: 82px;
  position: relative;
  z-index: 11;
  .inner {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-family: Alimama-ShuHeiTi;
      font-weight: 500;
      font-size: 41px;
      color: transparent;
      line-height: 50px;
      letter-spacing: 4px;
      text-align: left;
      font-style: normal;
      background: linear-gradient(180deg, #FFFFFF 0%, #9AC7CE 100%);
      background-clip: text;
    }
  }

  .left {
    width: 50%;
    height: 100%;
    position: relative;
  }

  .middle {
    position: absolute!important;
    left: 39%;
    width: 22%;
    .content {
      .inner {
        left: 0;
        top: 0;
        width: 100%;
        height: 90%;
        font-size: 30px;
      }
    }
  }

  .right {
    width: 50%;
    .content {
      .inner {
        right: 24px;
        top: 9px;
        height: 30px;
        line-height: 30px;
        justify-content: flex-end;
        color: #FFFFFF;
        .time {
          font-family: PingFangSC-Semibold;
          font-size: 22px;
          text-align: left;
          font-style: normal;
          margin-right: 23px;
          letter-spacing: .88px;
        }
        .week,.date {
          font-family: PingFangSC-Regular;
          font-size: 17px;
          text-align: left;
          font-style: normal;
          letter-spacing: .68px;
        }
        .week {
          margin-right: 15px;
        }
      }

    }
  }

  .left, .middle, .right {
    height: 100%;
    position: relative;

    .content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .time-left {
    display: flex;
    align-items: center;
    font-size: 20px;
    letter-spacing: 2px;
    text-shadow: 0 0 18px rgba(201, 233, 255, .9);
    span {
      color: #fff !important;
    }
    .mL20 {
      margin-left: 20px;
    }
    .mR20 {
      margin-right: 20px;
    }
  }

  .time-right {
    color: #fff;
    font-size: 9px;

    div {
      width: 100%;
      text-align: center;

      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/topHeader.vue